(() => {
  const root = document.querySelector('[data-tk9-hard-bottom-advertorial]');
  if (!root) return;

  const timers = root.querySelectorAll('[data-countdown]');
  const key = 'team-k9-advertorial-countdown-end-v3';
  const minimumDuration = 33 * 60 * 60 * 1000;
  const maximumDuration = 56 * 60 * 60 * 1000;
  const randomDuration = () => Math.floor(Math.random() * (maximumDuration - minimumDuration + 1)) + minimumDuration;
  let end = Number(sessionStorage.getItem(key));

  if (!end || end <= Date.now()) {
    end = Date.now() + randomDuration();
    sessionStorage.setItem(key, String(end));
  }

  const renderCountdown = () => {
    const remaining = Math.max(0, end - Date.now());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    const values = { days, hours, minutes, seconds };

    timers.forEach((timer) => {
      Object.entries(values).forEach(([unit, value]) => {
        timer.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0');
      });
      timer.setAttribute('aria-label', `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`);
    });

    if (remaining === 0) {
      end = Date.now() + randomDuration();
      sessionStorage.setItem(key, String(end));
    }
  };

  renderCountdown();
  window.setInterval(renderCountdown, 1000);

  const sticky = root.querySelector('[data-sticky-offer]');

  const updateSticky = () => {
    const shouldShow = window.scrollY > Math.min(760, window.innerHeight * 0.8);
    sticky.hidden = !shouldShow;
    document.body.classList.toggle('tk9-hard-bottom-sticky-visible', shouldShow);
  };

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky, { passive: true });
  updateSticky();
})();
